import React, { useEffect, useState } from 'react';
import { CContainer, CButton } from '@coreui/react';
import { CIcon } from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import WeaveTable from '../../components/WeaveTable/WeaveTable';
import { getWeaveRequestAction } from '../../store/weave/weaveActions';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';

const Weave = ({ weaveList, weaveData, getWeaveRequest }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [query, setQuery] = useState({
    WeaveIdFilter: null,
    WeaveGuid: null,
    YarnGuid: null,
    WeftPrdYarnGuid: null,
    WarpPrdYarnGuid: null,
    MinTotalWeight: null,
    MaxTotalWeight: null,
    PrdWeaveTypeGuid: null,
    WeaveCode: null,
    PrdCompositionGuid: null,
    MinWarpDensity: null,
    MaxWarpDensity: null,
    WarpDensity: null,
    MinWeftDensity: null,
    MaxWeftDensity: null,
    WeftDensity: null,
    ReedWidth: null,
    MinTotalThreads: null,
    MaxTotalThreads: null,
    TotalThreads: null,
    Description: null,
    ReedNo: null,
    Dgts: null,
    FabricWidth: null,
    FabricWeight: null,
    OrderBy: null,
    IsDescending: true,
    PageNumber: 1,
    PageSize: 10,
  });

  useEffect(() => {
    getWeaveRequest(query);
  }, [getWeaveRequest, JSON.stringify(query)]);

  const handleFilterChange = (filters) => {
    setQuery((prev) => ({
      ...prev,
      ...filters,
      PageNumber: 1,
    }));
  };

  const handleSortChange = (orderBy, isDescending) => {
    setQuery((prev) => ({
      ...prev,
      OrderBy: orderBy,
      IsDescending: isDescending,
      PageNumber: 1,
    }));
  };

  const handlePageChange = (pageNumber) => {
    setQuery((prev) => ({
      ...prev,
      PageNumber: pageNumber,
    }));
  };

  const handlePageSizeChange = (pageSize) => {
    setQuery((prev) => ({
      ...prev,
      PageSize: pageSize,
      PageNumber: 1,
    }));
  };

  const handleRefresh = () => {
    getWeaveRequest(query);
  };

  const handleCreateWeave = () => {
    navigate('/weave/create');
  };

  return (
    <div className="weave-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('weave')}</div>
        <WeaveTable
          weaveList={weaveList}
          weaveData={weaveData}
          query={query}
          onFilterChange={handleFilterChange}
          onSortChange={handleSortChange}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          onRefresh={handleRefresh}
        />
      </CContainer>

      <CButton
        color="primary"
        className="create-order-fab"
        onClick={handleCreateWeave}
        title={t('createWeave')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

const mapStateToProps = (state) => ({
  weaveData: state.weaveReducer.weaveData,
  weaveList: state.weaveReducer.weaveList,
});

const mapDispatchToProps = (dispatch) => ({
  getWeaveRequest: (payload) => dispatch(getWeaveRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Weave);
